export const BuildInfo = {timestamp:1773106923000}
